import React from 'react';

/**
 * Shared status pill used in both ImageCrushPage and ThemeCrushPage.
 *
 * @param {string} status       - one of: done, optimized, already_optimized, processing,
 *                                pending, skipped, cancelled, failed, error, reverted
 * @param {string} [message]    - tooltip text (shown on hover; requires tooltipId)
 * @param {string} [tooltipId]  - unique id for the paired <s-tooltip>
 */

const STATUS_CONFIG = {
  done:              { cls: 'mu-status-done',       label: 'Done',        spin: false },
  optimized:         { cls: 'mu-status-done',       label: '✓ Optimized', spin: false },
  already_optimized: { cls: 'mu-status-done',       label: '✓ Optimized', spin: false },
  processing:        { cls: 'mu-status-processing', label: 'Processing',  spin: true  },
  queued:            { cls: 'mu-status-pending',    label: 'Pending',     spin: false },
  pending:           { cls: 'mu-status-pending',    label: 'Pending',     spin: false },
  waiting:           { cls: 'mu-status-waiting',    label: 'Waiting',     spin: false },
  skipped:           { cls: 'mu-status-skipped',    label: 'Skipped',     spin: false },
  cancelled:         { cls: 'mu-status-skipped',    label: 'Skipped',     spin: false },
  failed:            { cls: 'mu-status-failed',     label: 'Failed',      spin: false },
  error:             { cls: 'mu-status-failed',     label: 'Error',       spin: false },
  reverted:          { cls: 'mu-status-waiting',    label: 'Reverted',    spin: false },
};

export function StatusPill({ status, message, tooltipId }) {
  const cfg = STATUS_CONFIG[status] || { cls: 'mu-status-waiting', label: status || '—', spin: false };
  return (
    <>
      <span
        className={`mu-status-pill ${cfg.cls}`}
        interestFor={message && tooltipId ? tooltipId : undefined}
      >
        {cfg.spin && <span className="tc-spin">⟳</span>} {cfg.label}
      </span>
      {message && tooltipId && <s-tooltip id={tooltipId}>{message}</s-tooltip>}
    </>
  );
}

export default StatusPill;
